import { accordionAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";
import { focusRing } from "../foundations/focus";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(accordionAnatomy.keys);

const baseStyle = definePartsStyle({
  root: {
    borderTop: "1px solid",
    borderColor: "line.hairline",
  },
  container: {
    borderTop: "none",
    borderBottom: "1px solid",
    borderColor: "line.hairline",
  },
  button: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "16px",
    px: 0,
    pr: "8px",
    py: "clamp(18px, 2.2vw, 26px)",
    fontSize: "faqQuestion",
    fontWeight: "light",
    lineHeight: "tight",
    textAlign: "left",
    textWrap: "balance",
    transitionProperty: "color",
    transitionDuration: "0.2s",
    transitionTimingFunction: "brand",
    _hover: { bg: "transparent", color: "brand.600" },
    _focusVisible: focusRing,
  },
  panel: {
    px: 0,
    pr: "44px",
    pt: 0,
    pb: "clamp(20px, 2.4vw, 28px)",
    fontSize: "body",
    lineHeight: "prose",
    color: "warm.600",
    textWrap: "pretty",
  },
  icon: {
    boxSize: "20px",
    color: "ink.DEFAULT",
    flexShrink: 0,
  },
});

export const Accordion = defineMultiStyleConfig({ baseStyle });
